const feelings = [
  { id: 1, label: "PERFECT", title: "حس عالی" },
  { id: 2, label: "NORMAL", title: "معمولی" },
  { id: 3, label: "LOW_ENERGY", title: "کم انرژی" },
  { id: 4, label: "WEAK_1", title: "کمی ضعف" },
  { id: 5, label: "WEAK_2", title: "ضعف شدید" },
  { id: 6, label: "BAD", title: "حس بد" },
];

export default feelings;